var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center no-perm"},[_c('div',{staticClass:"no-perm-content"},[_c('div',{staticClass:"inline-block"},[_c('img',{staticClass:"layout-logo-img",attrs:{"src":require("../../../static/image/is-upgrade.png")}}),_vm._v(" "),_c('div',{staticClass:"inline-block"},[_c('h2',[_vm._v(_vm._s(_vm.msg))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b831e962","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/home/upgrade.vue
// module id = null
// module chunks = 